"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9905 2.625c4.007 0 7.4121 3.4574 7.4121 7.4606 0 4.7561-3.6581 8.7836-7.4025 11.288-3.744-2.5057-7.4024-6.5309-7.4024-11.288 0-3.9992 3.382-7.4606 7.3928-7.4606zM14 9.2188c0 1.1045-.8954 2-2 2s-2-.8955-2-2c0-1.1046.8954-2 2-2s2 .8954 2 2z"
  })];
};

exports.default = _default;